import { render, staticRenderFns } from "./coordinateSystemScatter.vue?vue&type=template&id=2c940a3c&scoped=true"
import script from "./coordinateSystemScatter.vue?vue&type=script&lang=js"
export * from "./coordinateSystemScatter.vue?vue&type=script&lang=js"
import style0 from "./coordinateSystemScatter.vue?vue&type=style&index=0&id=2c940a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c940a3c",
  null
  
)

export default component.exports